function PerformersCtrl() {
  const vm = this;

  vm.config = vm.config || {};
  vm.config.add = function () {
    vm.addPerformer();
  };
  vm.performers = vm.config.performers || [];

  vm.addPerformer = function addPerformer($event) {
    if ($event) $event.preventDefault();

    vm.performers.push({
      name: 'Artist 1',
      website: null,
      group: false
    });
  };

  vm.removePerformer = function removePerformer(fee) {
    if (!fee) return;

    const index = vm.performers.indexOf(fee);

    if (index >= 0) {
      vm.performers.splice(index, 1);
    }
  };
}

PerformersCtrl.$inject = [];

export default PerformersCtrl;



// WEBPACK FOOTER //
// ./src/directives/performers/controller.js